import {
  openCalendlyNotModal,
  showConfirmationScreen,
} from "../components/form/postSubmit/util";
import { setupCalendly, calendly, constants } from "../components/calendly";
import { app, DEVELOPMENT } from "../../../config/env";
import { initDynamicNearbyLocations } from "../components/dynamicNearbyLocations/index";
import getNearestPlaces from "../components/geolocation";

const calendlyListener = (openModalNotCalendly, $ctaButtons) => () => {
  //  deregister listener
  openModalNotCalendly();
  $ctaButtons.off("click");
};

getNearestPlaces().then((places) => {
  initDynamicNearbyLocations([places.locations[0].id, places.locations[1].id]);
});

const getTourLink = () => {
  const $select = $("select[name=location_calendly]");
  const tourLink =
    app.appEnv === DEVELOPMENT ? constants.TESTING_CALENDLY : $select.val();

  return tourLink;
};

const ctaButtonOnClickOpenCalendly = ($footerForm, $ctaButtons) => () => {
  const link = getTourLink();
  const openModalNotCalendly = openCalendlyNotModal($footerForm, link, {});
  const scheduledCallback = calendlyListener(openModalNotCalendly, $ctaButtons);
  calendly(link, {}, { scheduledCallback });
};

$(function () {
  //  goal is to override the default marketo form submit behavior of the footer form
  const $footerForm = $("form[name=bookTourForm]");
  const $ctaButtons = $('button[data-target="#modal-location-form"]');

  //  get Calendly loaded
  setupCalendly();

  //  change the footer form to confirmation message
  showConfirmationScreen("bookTourForm");

  //  cta on click will open calendly
  $ctaButtons.click(ctaButtonOnClickOpenCalendly($footerForm, $ctaButtons));
});
